import React from "react";
import { Award, Shield, TrendingUp, FileCheck } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { legalDocuments } from "@/data/mock";

export default function SertifikasiDanKeunggulanSection() {
  const certifications = [
    {
      icon: Shield,
      title: "Sertifikat Halal",
      description: "Didukung dokumen sertifikasi Halal untuk meningkatkan kepercayaan konsumen dan mitra.",
    },
    {
      icon: Award,
      title: "CPPOB",
      description: "Dokumen CPPOB sebagai bukti komitmen proses produksi yang baik dan terstandar.",
    },
    {
      icon: TrendingUp,
      title: "Izin Edar Produk",
      description: "Dokumen izin edar tersedia untuk produk sesuai ketentuan yang berlaku.",
    },
    {
      icon: FileCheck,
      title: "HKI / Brand Protection",
      description: "Brand SHAKTI/CABEAI didukung bukti perlindungan merek (HKI).",
    },
  ];

  return (
    <section id="sertifikasi" className="certifications-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">Legalitas & Keunggulan</span>
          <h2 className="section-title">
            Terjamin <span className="text-accent">Resmi</span> dan{" "}
            <span className="text-accent">Terpercaya</span>
          </h2>
          <p className="section-description">
            Komitmen kami terhadap kualitas dan kepatuhan dibuktikan dengan dokumen legalitas dan sertifikasi yang dapat Anda cek.
          </p>
        </div>

        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <Card key={index} className="certification-card">
              <CardContent className="certification-content">
                <div className="cert-icon-wrapper">
                  <cert.icon className="cert-icon" />
                </div>
                <h3 className="cert-title">{cert.title}</h3>
                <p className="cert-description">{cert.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Dokumen legalitas */}
        {/* <div style={{ marginTop: 24 }}>
          <h3 style={{ fontWeight: 900, marginBottom: 10 }}>Dokumen Legalitas</h3>
          
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {legalDocuments.map((d) => (
              <a
                key={d.file}
                href={encodeURI(d.file)}
                target="_blank"
                rel="noreferrer"
                style={{
                  padding: "8px 12px",
                  borderRadius: 10,
                  border: "1px solid rgba(160,14,33,0.25)",
                  fontWeight: 800,
                  color: "#a00e21",
                  fontSize: 13,
                  textDecoration: "none",
                  background: "white",
                }}
              >
                {d.label}
              </a>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
}
